const productVariants = {
  apiClient: null,

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async listForProduct(productId) {
    try {
      const response = await this.apiClient.get(`/admin/products/${productId}/variants`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await this.apiClient.get(`/admin/product-variants/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(productId, form) {
    try {
      const response = await this.apiClient.post(`/admin/products/${productId}/variants`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, form) {
    try {
      const response = await this.apiClient.put(`/admin/product-variants/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await this.apiClient.delete(`/admin/product-variants/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async uploadImage(id, form) {
    try {
      const response = await this.apiClient.post(`/admin/product-variants/${id}/image`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async removeImage(id, imageId) {
    try {
      const response = await this.apiClient.delete(`/admin/product-variants/${id}/images/${imageId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default productVariants;
